import React, { useEffect, useRef, useState } from "react";
import useAuthMoadl from "../store/authWarningModal";

import Login from "../pages/pages/auth/login";
import Signup from "../pages/pages/auth/signup";
import ForgotPassword from "../pages/pages/auth/forgot-password"; // import your component

const Modal = () => {
    const { isShown, type, hide } = useAuthMoadl((state) => state);

    const [toggleAuth, setTogglAuth] = useState(type || "signin");
    const containerRef = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                hide();
            }
        }

        isShown && document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.body.classList.remove("overflow-hidden");
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [containerRef, isShown, hide]);

    if (!isShown) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-white/70 dark:bg-black/50 backdrop-blur-sm">
            <div
                className="relative w-full max-w-2xl p-4 bg-white dark:bg-slate-900 rounded-lg shadow-lg flex flex-col gap-6"
                ref={containerRef}
            >
                {toggleAuth === "signin" && <Login setTogglAuth={setTogglAuth} />}
                {toggleAuth === "signup" && <Signup setTogglAuth={setTogglAuth} />}
                {toggleAuth === "forgot" && <ForgotPassword setTogglAuth={setTogglAuth} />}
            </div>
        </div>
    );
};

export default Modal;
